<template>
  <div class="header clearfix">
    <div class="logo fl">
      <a href="javascript:void(0)" title="华振公司">
        <img src="../assets/images/index/logo.png" />
      </a>
    </div>
    <div class="header-main fr">
      <div class="header-nav clearfix">
        <div class="header-navMain fr">
          <div class="nav-item" v-for="item in list" @mouseenter="item.showState = true" @mouseleave="item.showState = false" :style="{ height: item.showState ? 200 + 'px' : 'auto' }">
            <div @click="navgoto(item.url)">
              <span v-if="item.selectState" class="nav-item-titleSelect">{{item.title}}</span>
              <span v-else class="nav-item-title">{{item.title}}</span>
            </div>
            <div class="nav-float" v-if="item.navList.length != 0" v-show="item.showState">
              <div class="nav-arrow"></div>
              <div class="nav-list">
                <div class="nav-title" v-for="it in item.navList">
                  <div @click="navgoto(it.url)">
                    <span class="nav-titleText">{{it.title}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data() {
      return {
        list: [{
          title: "首页",
          url: "/",
          selectState: true,
          showState: false,
          navList: []
        }, {
          title: "走进华振",
          url: "/introduce",
          selectState: false,
          showState: false,
          navList: [{
            title: "公司简介",
            url: "/introduce?part=1"
          }, {
            title: "管理团队",
            url: "/introduce?part=2"
          }, {
            title: "愿景与使命",
            url: "/introduce?part=3"
          }]
        }, {
          title: "我们的服务",
          url: "/service",
          selectState: false,
          showState: false,
          navList: [{
            title: "投融资咨询",
            url: "/service?type=supplychain"
          }, {
            title: "海外资产配置咨询",
            url: "/service?type=finance"
          }, {
            title: "企业战略咨询",
            url: "/service?type=familyoffice"
          }, {
            title: "ABBC实验室",
            url: "/service?type=ABBClab"
          }]
        }, {
          title: "华振动态",
          url: "/news",
          selectState: false,
          showState: false,
          navList: [{
            title: "公司新闻",
            url: "/news?type=company"
          }, {
            title: "主题论坛",
            url: "/news?type=themeforum"
          }, {
            title: "公益慈善",
            url: "/news?type=charity"
          }, {
            title: "员工活动",
            url: "/news?type=employee"
          }]
        }, {
          title: "联系我们",
          url: "/contact",
          selectState: false,
          showState: false,
          navList: []
        }]
      }
    },
    methods: {
      navgoto(url) {
        this.$router.push({
          path: url
        });
      },
      updateNav() {
        this.list.forEach(function (value, index) {
          value.selectState = false;
        });
        let route = location.pathname;
        let index = 0;
        switch (route) {
          case "/":
            index = 0;
            break;
          case "/introduce":
            index = 1;
            break;
          case "/introduceleaders":
            index = 1;
            break;
          case "/service":
            index = 2;
            break;
          case "/news":
            index = 3;
            break;
          case "/contact":
            index = 4;
            break;
          default:
            break;
        }

        this.list[index].selectState = true;
      }
    },
    watch: {
      "$route": "updateNav"
    }
  }
</script>

<style scoped>
  .header {
    margin: 0px auto;
    padding: 25px 0 30px;
    width: 1200px;
  }

  .logo {
    width: 250px;
    height: 90px;
  }

  .header-main {
    padding-top: 13px;
    width: 900px;
    height: 90px;
  }

  .header-nav {}

  .header-navMain {
    margin-top: 24px;
  }

  .nav-item {
    position: relative;
    float: left;
    padding: 1.5px 26px;
    text-align: center;
    font-size: 20px;
  }

  .nav-item-title {
    color: #666;
  }

  .nav-item-title:hover {
    cursor: pointer;
  }

  .nav-item-titleSelect {
    color: #005BAB;
    font-weight: bold;
  }

  .nav-item-titleSelect:hover {
    cursor: pointer;
  }

  .nav-float {
    position: absolute;
    top: 42px;
    left: -12px;
    z-index: 9;
    width: 160px;
  }

  .nav-arrow {
    margin-left: 72px;
    width: 1px;
    height: 1px;
    border: 6px solid transparent;
    border-bottom: 6px solid #000000;
  }

  .nav-list {
    padding-top: 10px;
    background: #000000;
    color: #fff;
    text-align: center;
  }

  .nav-title {
    float: inherit;
    font-size: 14px;
    text-align: center;
    margin-right: 0;
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0px;
  }

  .nav-title:hover {
    background: #077dff;
    cursor: pointer;
  }

  .nav-titleText {
    color: #fff;
    height: 100%;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue